function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { createElement as _createElement } from 'react';
import { FocusZone, FocusZoneTabbableElements } from 'office-ui-fabric-react';
import { useInputGroup } from '../../../machines/inputGroupMachine/useInputGroup';
import { jsx as _jsx } from "react/jsx-runtime";
export function EditorRow(props) {
  const children = !props.disabled && props.selected ? /*#__PURE__*/_jsx(Editing, _objectSpread({}, props)) : /*#__PURE__*/_jsx(NotEditing, _objectSpread({}, props));
  return /*#__PURE__*/_jsx(FocusZone, {
    "data-is-focusable": true,
    id: "table-row".concat(props.row.id),
    className: "row-focus",
    handleTabKey: FocusZoneTabbableElements.all,
    onFocus: ev => {
      const target = ev.target;
      if (target !== null && target !== void 0 && target.closest('[data-no-row-select="true"]')) {
        return;
      }
      if (props.disableAutoFocus) {
        return;
      }

      // Despite .focus() being called, this line is directly causing auto focus on the first input in the row
      // What is more, when select() is not triggered, it does prevent from TAB to work when navigating between rows in the table
      if (props.select) {
        props.select();
      }
      const currentTarget = ev.currentTarget;
      if (currentTarget && currentTarget.querySelector) {
        if (currentTarget.matches('.row-focus')) {
          const firstTabble = currentTarget.querySelector('input, textarea, select, details');
          if (firstTabble && target && target.id.indexOf('table-row') > -1) {
            firstTabble.focus();
          }
        }
      }
    },
    children: children
  });
}
export function NotEditing(_ref) {
  let {
    row,
    style = {
      borderBottom: '1px solid rgb(244, 244, 244)',
      minHeight: '42px'
    },
    disabled,
    selected,
    select
  } = _ref;
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, row.getRowProps({
    style
  })), {}, {
    children: row.cells.map(cell => {
      return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, cell.getCellProps()), {}, {
        style: cell.getCellProps().style,
        children: cell.render('Cell', {
          disabled,
          selected,
          select
        })
      }));
    })
  }));
}
function Editing(_ref2) {
  let {
    row,
    style = {
      borderBottom: '1px solid rgb(244, 244, 244)'
    },
    inputList,
    disableInvalidIndicator,
    onUpdate,
    onValidation,
    onValidationError,
    disabled,
    select,
    selected
  } = _ref2;
  const context = {
    data: row.original,
    inputList: inputList.map(input => input),
    validateOnInitialise: true
  };
  const services = {
    onValidation: onValidation ? onValidation : async _ctx => {},
    onValidationError: async (ctx, e) => {
      if (onUpdate && ctx !== null && ctx !== void 0 && ctx.data) {
        onUpdate(ctx.data, row.index);
      }
      if (onValidationError) await onValidationError(ctx, e);
    },
    onChange: async ctx => {
      if (onUpdate && ctx.data) {
        onUpdate(ctx.data, row.index);
      }
    }
  };
  const group = useInputGroup(context, services, true);
  let rowstyle = undefined;
  if (group.state.matches('active.ready.inValid') && !disableInvalidIndicator) {
    rowstyle = _objectSpread(_objectSpread({}, style), {}, {
      borderColor: 'red',
      borderWidth: '2px',
      borderStyle: 'none none none solid'
    });
  }
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, row.getRowProps(_objectSpread({}, {
    style: _objectSpread(_objectSpread({}, rowstyle), {}, {
      minHeight: '42px'
    })
  }))), {}, {
    children: row.cells.map((cell, i) => {
      return /*#__PURE__*/_createElement("div", _objectSpread(_objectSpread({}, cell.getCellProps()), {}, {
        style: _objectSpread({}, cell.getCellProps().style),
        key: "cell-".concat(i)
      }), cell.render('Cell', {
        disabled,
        selected,
        select,
        inputService: group.inputRefs ? group.inputRefs[cell.column.id] : undefined,
        editRowState: group.state,
        sendInputGroupEvent: group.send,
        key: "c".concat(i)
      }));
    })
  }));
}